// @utitlites
import getProductsFromAggregatorData from './getProductsFromAggregatorData'

// @constants
const { ACCOUNTS } = require('constants/aggregator/products')

const getAccountsFromAggregatorData = (immAggregatorData) => {
    const productList = getProductsFromAggregatorData(immAggregatorData)
    return productList.filter(product => product.product === ACCOUNTS)
}

export default getAccountsFromAggregatorData;